import { animated } from 'react-spring';
import styled from 'styled-components';

import { darkGreyColor, redColor } from 'js/config/style';

export default animated(styled.div`
  background: ${({ type }) => (type === 'message' ? darkGreyColor : redColor)};
  color: white;
  line-height: 2rem;
  border-radius: 2rem;
  pointer-events: auto;
  display: inline-block;
  padding: 0 1rem;
  position: relative;
`);
